// extracted by mini-css-extract-plugin
export default {"selector":"Customer_selector__mbpWn","singleCustomer":"Customer_singleCustomer__dviMq","error":"Customer_error__MCetS"};